import { useState } from 'react';
import InterestModal from './InterestModal';

export default function PartnershipCall() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <section className="py-24 bg-gradient-to-br from-[#FF6B6B] via-[#FF8E53] to-[#FFA07A] text-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
      </div>

      <div className="container mx-auto px-6 lg:px-12 relative z-10">
        <div className="max-w-4xl mx-auto">
          
          {/* Step 1: المشكلة */}
          <div className="text-center mb-16">
            <span className="inline-block px-6 py-2 bg-blue-600/60 backdrop-blur-sm rounded-full text-sm font-semibold mb-6">
              المشكلة
            </span>
            <h2 className="text-4xl lg:text-5xl font-bold mb-6" style={{ lineHeight: '1.75' }}>
              الجهات تبحث عن المواهب<br />
              المواهب تبحث عن الفرص
            </h2>
            <p className="text-xl text-white/90 leading-relaxed">
              لكن الطرفان لا يجدان بيئة تجمعهما بطريقة مستدامة وفعّالة
            </p>
          </div>

          {/* Step 2: التوتر والتكلفة */}
          <div className="bg-white/10 backdrop-blur-sm p-8 rounded-3xl border border-white/20 mb-16">
            <div className="text-center mb-8">
              <span className="inline-block px-6 py-2 bg-red-500/30 rounded-full text-sm font-semibold mb-4">
                التكلفة الحقيقية
              </span>
              <h3 className="text-3xl font-bold mb-6">ماذا يحدث عند غياب هذه البيئة؟</h3>
            </div>
            <div className="grid md:grid-cols-3 gap-6">
              <div className="text-center">
                <div className="w-16 h-16 bg-red-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-close-circle-line text-3xl"></i>
                </div>
                <p className="font-semibold">ضياع المواهب</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 bg-red-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-time-line text-3xl"></i>
                </div>
                <p className="font-semibold">بطء الابتكار</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 bg-red-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-money-dollar-circle-line text-3xl"></i>
                </div>
                <p className="font-semibold">تكاليف توظيف عالية</p>
              </div>
            </div>
          </div>

          {/* Step 3: الحل */}
          <div className="text-center mb-16">
            <span className="inline-block px-6 py-2 bg-blue-600/60 backdrop-blur-sm rounded-full text-sm font-semibold mb-6">
              الحل
            </span>
            <div className="bg-white/10 backdrop-blur-sm p-10 rounded-3xl border-2 border-white/30">
              <div className="w-20 h-20 bg-white rounded-full flex items-center justify-center mx-auto mb-6">
                <span className="text-5xl">🤝</span>
              </div>
              <h3 className="text-3xl lg:text-4xl font-bold mb-4">
                مساحة شباب المدعومة من الجهات
              </h3>
              <p className="text-xl text-white/90 leading-relaxed mb-6">
                منصة تربط المواهب بالفرص والجهات بالمستقبل
              </p>
              <div className="inline-block bg-[#FFE5B4] text-gray-900 px-8 py-3 rounded-full font-bold">
                ✓ استثمار ذكي، ليس تكلفة
              </div>
            </div>
          </div>

          {/* Step 4: الإثبات - الفوائد */}
          <div className="mb-16">
            <div className="text-center mb-10">
              <span className="inline-block px-6 py-2 bg-blue-600/60 backdrop-blur-sm rounded-full text-sm font-semibold mb-4">
                لماذا الآن؟
              </span>
              <h3 className="text-3xl font-bold">ما الذي ستحصل عليه؟</h3>
            </div>
            <div className="grid md:grid-cols-2 gap-6">
              <div className="bg-white/10 backdrop-blur-sm p-6 rounded-2xl border border-white/20">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-team-line text-2xl"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-lg mb-2">وصول مباشر للمواهب</h4>
                    <p className="text-white/80 text-sm">اكتشف وتواصل مع أفضل الكفاءات قبل المنافسين</p>
                  </div>
                </div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm p-6 rounded-2xl border border-white/20">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-award-line text-2xl"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-lg mb-2">تعزيز العلامة التجارية</h4>
                    <p className="text-white/80 text-sm">ارتباط مباشر بالابتكار والمسؤولية الاجتماعية</p>
                  </div>
                </div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm p-6 rounded-2xl border border-white/20">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-lightbulb-line text-2xl"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-lg mb-2">ابتكار مفتوح</h4>
                    <p className="text-white/80 text-sm">تعاون مع مشاريع ناشئة وأفكار جديدة</p>
                  </div>
                </div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm p-6 rounded-2xl border border-white/20">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-heart-line text-2xl"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-lg mb-2">أثر مجتمعي قابل للقياس</h4>
                    <p className="text-white/80 text-sm">تقارير شفافة عن العائد الاجتماعي</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      {/* Interest Modal */}
      <InterestModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)}
        projectName="مساحة شباب - شراكة استراتيجية"
      />
    </section>
  );
}
